<template>
  <div class="aspect-ratio-box" :style="ratioStyle">
    <div class="aspect-ratio-box-inside">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AspectRatioBox',
    props: {
      ratio: {
        type: String,
        default: '1:1'
      }
    },
    computed: {
      ratioStyle () {
        const pieces = this.ratio.split(':')
        if (pieces.length !== 2) {
          return { paddingTop: '100%' }
        }
        const width = parseInt(pieces[0], 10)
        const height = parseInt(pieces[1], 10)
        return { paddingTop: `${height / width * 100}%` }
      }
    }
  }
</script>

<style scoped>
  .aspect-ratio-box {
    height: 0;
    overflow: hidden;
    position: relative;
  }

  .aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/AspectRatioBox.vue